import { render, staticRenderFns } from "./LiveMatrix.vue?vue&type=template&id=610cbd05&scoped=true&"
import script from "./LiveMatrix.js?vue&type=script&lang=js&"
export * from "./LiveMatrix.js?vue&type=script&lang=js&"
import style0 from "./LiveMatrix.vue?vue&type=style&index=0&id=610cbd05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610cbd05",
  null
  
)

export default component.exports